<template>
  <div class="header">
    <div class="logoContent">
      <div class="logoBox"></div>
    </div>
    <div class="menubtn" @click="openMenu">
      <div class="menuBox"></div>
    </div>
    <van-popup v-model="show" position="right" :style="{width:'max-content', top:'25%',padding:'0 1em' }" >
      <div class="menuContent">
        <ul class="menuBox">
          <li class="menuList" v-for="(item, index) in menus" @click="goPages(item)" :key="index">{{item.name}}</li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'headers',
  data() {
    return {
      show: false,
      menus: [
        {
          name: '申请调解',
          url: '/application/cmmonUserApply',
        },
        {
          name: '中心简介',
          url: '/aboutUs/centerProfile',
        },
        {
          name: '联系我们',
          url: '/aboutUs/contactUs',
        },
        {
          name: '我的案件',
          url: '/user/center',
        },
      ],
    };
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    goPages(item) {
      if (item.url === this.$route.path) {
        this.show = false;
        return;
      }
      this.$router.push({ path: item.url });
    },
    openMenu() {
      this.show = !this.show;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 1px 0px 0px rgba(31, 31, 31, 0.05);
  display: flex;
  justify-content: space-between;
  .logoContent {
    height: 100%;
    display: flex;
    align-items: center;
    .logoBox {
      width: 210px;
      height: 34px;
      margin-left: 10px;
      overflow: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url('../assets/img/logo.png');
    }
  }
  .menubtn {
    padding: 0 10px;
    height: 100%;
    display: flex;
    align-items: center;
    .menuBox {
      cursor: pointer;
      width: 22px;
      height: 18px;
      overflow: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url('../assets/img/menu.png');
    }
  }
  ::v-deep .van-overlay {
    height: calc(100% - 50px);
    top: 50px;
  }
  ::v-deep .van-popup--right {
    right: 5px;
    background: #FFFFFF;
    box-shadow: 0px 6px 9px 0px rgba(176, 176, 176, 0.18);
    border-radius: 8px;
    .menuContent {
      padding: 10px;
      .menuList {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
        border-bottom: 1px solid #f7f7f7;
        text-align: center;
      }
      .menuList:last-child{
        border-bottom: none;
      }
    }
  }
}
</style>
